<div class="wrap">
  <div class="top">
    <app-modal-generic-header
      [header]="'@components.deleteProfile.header' | translate"
      (closeClicked)="modalService.dismiss(false)"
    ></app-modal-generic-header>
  </div>
  <div class="content">
    <div class="info-text">
      {{ "@components.deleteProfile.confirmationText.1" | translate }}
    </div>
    <div class="info-text important">
      {{ "@components.deleteProfile.confirmationText.2" | translate }}
    </div>
    <div class="form">
      <app-input
        [control]="form.controls.currentPassword"
        [iconName]="'lock'"
        [label]="'@components.deleteProfile.form.password.label' | translate"
        [placeholder]="
          '@components.deleteProfile.form.password.placeholder' | translate
        "
      ></app-input>
      <div class="error-message" *ngIf="requestFailedWithError === true">
        {{ "@components.deleteProfile.errorMessage" | translate }}
      </div>
    </div>
    <div class="buttons">
      <app-action-button
        [isLoading]="(loader.isLoading$ | async)!"
        [label]="'@components.deleteProfile.cta' | translate"
        [disabled]="form.invalid"
        (click)="onDeleteAccount()"
      ></app-action-button>
    </div>
  </div>
</div>
